import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Capabilities from './pages/Capabilities';
import PayrollCompliance from './pages/PayrollCompliance';
import Industries from './pages/Industries';
import Innovation from './pages/Innovation';
import CapitalPartners from './pages/CapitalPartners';
import Contact from './pages/Contact';
import ClientPortal from './pages/ClientPortal';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  const isPortal = pathname === '/client-portal';

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/payroll-compliance" element={<PayrollCompliance />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/capital-partners" element={<CapitalPartners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/client-portal" element={<ClientPortal />} />
        </Routes>
      </main>
      {!isPortal && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout />
    </BrowserRouter>
  );
}
